import { Flex } from '@chakra-ui/react';

import { Delete } from 'assets/assetsV1/iconComponents';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';

const TitleComponent = () => (
  <Flex justify="center" align="center">
    <Flex justify="center" align="center">
      <Delete boxSize="20px" />
    </Flex>
    <span style={{ marginLeft: '4px' }}>Delete Tag</span>
  </Flex>
);

export const CustomTagDeletionModal = ({ isOpen, onCancel = () => {}, onContinue = () => {} }) => (
  <ConfirmationModal
    isCentered
    isOpen={isOpen}
    onClose={() => onCancel()}
    title={<TitleComponent />}
    body="This tag may already be in use. Deleting the same would remove it for all instances. Are you sure you want to continue?"
    cancelText="Cancel"
    onCancel={() => onCancel()}
    continueText="Delete"
    onContinue={() => onContinue()}
    continueButtonProps={{ color: 'red' }}
  />
);
